module.exports = __webpack_public_path__ + "static/media/cleany-tasks.312b8d54.jpg";